// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.migration-modal .paylixecommerce-modal-header .icon-container {
  width: 40px;
  height: 40px;
  background-color: var(--black1);
  border-radius: 8px;
  margin-right: 12px;
}
.migration-modal .paylixecommerce-modal-header .icon-container .migrate-icon {
  color: var(--black5);
  font-size: 20px;
}
.migration-modal .paylixecommerce-modal-header .header-content .title {
  font-size: 14px;
  font-weight: 600;
  color: var(--black9);
  margin: 0;
  line-height: 1.2;
}
.migration-modal .paylixecommerce-modal-header .header-content .description {
  font-size: 14px;
  font-weight: 400;
  color: var(--black5);
  margin: 4px 0 0 0;
  line-height: 1.4;
}
.migration-modal .paylixecommerce-modal-header .step-indicator {
  font-size: 12px;
  color: var(--black5);
  background-color: var(--black1);
  padding: 4px 8px;
  border-radius: 4px;
}
.migration-modal .paylixecommerce-modal-header .step-indicator .step-text-short {
  display: none;
}
.migration-modal .paylixecommerce-modal-header .step-indicator .step-text-full {
  display: inline;
}
@media (max-width: 575px) {
  .migration-modal .paylixecommerce-modal-header .step-indicator .step-text-short {
    display: inline;
  }
  .migration-modal .paylixecommerce-modal-header .step-indicator .step-text-full {
    display: none;
  }
}
.migration-modal .migration-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.migration-modal .migration-items .migration-item {
  border: 1px solid var(--black2);
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  background-color: transparent;
  transition: all 0.2s ease;
}
.migration-modal .migration-items .migration-item.selected {
  background-color: var(--black1);
  border-color: var(--primary);
}
.migration-modal .migration-items .migration-item:hover {
  border-color: var(--black3);
}
.migration-modal .migration-items .migration-item .item-content {
  display: flex;
  align-items: center;
}
.migration-modal .migration-items .migration-item .item-content .item-info .item-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--black9);
  margin-bottom: 4px;
}
.migration-modal .migration-items .migration-item .item-content .item-info .item-description {
  font-size: 12px;
  color: var(--black5);
}
.migration-modal .paylixecommerce-checkbox {
  min-height: unset;
  margin-bottom: 0%;
  margin-top: 0%;
  margin-right: 0%;
}
.migration-modal .validation-error {
  margin-bottom: 12px;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/layouts/dashboard/sidebar/MigrationModal.scss"],"names":[],"mappings":"AAEE;EACC,WAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;AADH;AAGG;EACC,oBAAA;EACA,eAAA;AADJ;AAMG;EACC,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,SAAA;EACA,gBAAA;AAJJ;AAOG;EACC,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;AALJ;AASE;EACC,eAAA;EACA,oBAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;AAPH;AASG;EACC,aAAA;AAPJ;AAUG;EACC,eAAA;AARJ;AAWG;EACC;IACC,eAAA;EATH;EAYE;IACC,aAAA;EAVH;AACF;AAeC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAbF;AAeE;EACC,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,yBAAA;AAbH;AAeG;EACC,+BAAA;EACA,4BAAA;AAbJ;AAgBG;EACC,2BAAA;AAdJ;AAiBG;EACC,aAAA;EACA,mBAAA;AAfJ;AAkBK;EACC,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AAhBN;AAmBK;EACC,eAAA;EACA,oBAAA;AAjBN;AAwBC;EACC,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAtBF;AAyBC;EACC,mBAAA;AAvBF","sourcesContent":[".migration-modal {\n\t.paylixecommerce-modal-header {\n\t\t.icon-container {\n\t\t\twidth: 40px;\n\t\t\theight: 40px;\n\t\t\tbackground-color: var(--black1);\n\t\t\tborder-radius: 8px;\n\t\t\tmargin-right: 12px;\n\n\t\t\t.migrate-icon {\n\t\t\t\tcolor: var(--black5);\n\t\t\t\tfont-size: 20px;\n\t\t\t}\n\t\t}\n\n\t\t.header-content {\n\t\t\t.title {\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: var(--black9);\n\t\t\t\tmargin: 0;\n\t\t\t\tline-height: 1.2;\n\t\t\t}\n\n\t\t\t.description {\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tcolor: var(--black5);\n\t\t\t\tmargin: 4px 0 0 0;\n\t\t\t\tline-height: 1.4;\n\t\t\t}\n\t\t}\n\n\t\t.step-indicator {\n\t\t\tfont-size: 12px;\n\t\t\tcolor: var(--black5);\n\t\t\tbackground-color: var(--black1);\n\t\t\tpadding: 4px 8px;\n\t\t\tborder-radius: 4px;\n\n\t\t\t.step-text-short {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\n\t\t\t.step-text-full {\n\t\t\t\tdisplay: inline;\n\t\t\t}\n\n\t\t\t@media (max-width: 575px) {\n\t\t\t\t.step-text-short {\n\t\t\t\t\tdisplay: inline;\n\t\t\t\t}\n\n\t\t\t\t.step-text-full {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.migration-items {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 12px;\n\n\t\t.migration-item {\n\t\t\tborder: 1px solid var(--black2);\n\t\t\tborder-radius: 8px;\n\t\t\tpadding: 16px;\n\t\t\tcursor: pointer;\n\t\t\tbackground-color: transparent;\n\t\t\ttransition: all 0.2s ease;\n\n\t\t\t&.selected {\n\t\t\t\tbackground-color: var(--black1);\n\t\t\t\tborder-color: var(--primary);\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tborder-color: var(--black3);\n\t\t\t}\n\n\t\t\t.item-content {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\n\t\t\t\t.item-info {\n\t\t\t\t\t.item-label {\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\tcolor: var(--black9);\n\t\t\t\t\t\tmargin-bottom: 4px;\n\t\t\t\t\t}\n\n\t\t\t\t\t.item-description {\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tcolor: var(--black5);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.paylixecommerce-checkbox {\n\t\tmin-height: unset;\n\t\tmargin-bottom: 0%;\n\t\tmargin-top: 0%;\n\t\tmargin-right: 0%;\n\t}\n\n\t.validation-error {\n\t\tmargin-bottom: 12px;\n\t}\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
